/**
 * [Impure?] Return a function that sorts an array of objects by order of given keys.
 * @param keys - Array of keys to order sort by.
 * @param isDescending - Boolean to determine sorting direction.
 */
export function sortBy(keys: Array <string>, isDescending?: boolean): any {
    return function (a: any, b: any) {                                  // Return sorter function.
        for (let i = 0; i < keys.length; i++) {                         // Iterate over sort keys, exiting whenever anything matches.
            if (a[keys[i]] < b[keys[i]]) return isDescending ? 1 : -1;  // Compare values and return if matched.
            if (a[keys[i]] > b[keys[i]]) return isDescending ? -1 : 1;  // Compare values and return if matched.
        }
        return 0;                                                       // Return 0 if all values end up equal.
    };
}
